/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PartsDto } from './partsDto';
import { UploadedPartsDto } from './uploadedPartsDto';


export interface MultiPartObjDto { 
    key: string;
    name: string;
    uploadId: string;
    parts?: object;
    preSignedUrls?: object;
    etagsArr?: Array<PartsDto>;
    uploadedParts?: UploadedPartsDto;
}

